import { Select } from "antd";
import React from "react";
import { cn } from "../../utils/cn";

const CommonSelect = ({ placeholder, options, value, onChange, className, ...props }) => {
    return (
        <Select
            options={options}
            placeholder={placeholder}
            onChange={onChange}
            value={value}
            {...props}
            className={cn(
                `
        h-10 w-full
        [&_.ant-select-selector]:hover:!border-primary
        [&_.ant-select-selector]:focus-within:!border-primary
        `,
                className
            )}
        />
    );
};

export default CommonSelect;
